import { Component, EventEmitter, Input, NgZone, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AblyMessageData } from '@models/ably';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AblyChannel } from '@services/ably-channels.service';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'vnm-ably-channel-subscription',
  templateUrl: './ably-channel-subscription.component.html',
  styleUrls: ['./ably-channel-subscription.component.scss']
})
export class AblyChannelSubscriptionComponent implements OnChanges {
  @Input() channel: AblyChannel;

  @Output() errorEvent = new EventEmitter<AblyMessageData>();
  @Output() successEvent = new EventEmitter<AblyMessageData>();
  @Output() completionEvent = new EventEmitter<AblyMessageData>();

  pushData$ = new ReplaySubject<AblyMessageData>(1);
  pushMessages$ = this.pushData$.pipe(
    tap((item) => {
      if (!item.success && !item.complete) {
        this.errorEvent.emit(item);
      } else if (item.success && !item.complete) {
        this.successEvent.emit(item);
      } else if (item.complete) {
        this.completionEvent.emit(item);
      }
    })
  );

  constructor(private zone: NgZone) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.channel) {
      this.channel?.subscribe('push', ({ data }) => {
        this.zone.run(() => {
          this.pushData$.next(data);
        });
      });
    }
  }
}
